import styled, { CSSObject } from '@emotion/styled';
import { forwardRef } from 'react';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

type TextareaProps = {
  width?: CSSObject['width'];
  height?: CSSObject['height'];
  name?: string;
  disabled?: boolean;
  fontSize?: keyof typeof defaultTheme.font.size;
  hasError?: boolean;
  ref?: any;
};

const getFontSize = (fontSize?: keyof typeof defaultTheme.font.size) => {
  if (fontSize) {
    return ['xs', 's'].includes(fontSize) ? defaultTheme.font.size.m : fontSize;
  }
  return defaultTheme.font.size.m;
};

const getTransformScale = (fontSize?: keyof typeof defaultTheme.font.size) => {
  // デフォルトのサイズをsとする
  if (!fontSize || fontSize === 's') {
    return 14 / 16;
  }
  if (fontSize === 'xs') {
    return 12 / 16;
  }
  return 1;
};

// widthをheightが縮小される分を拡大する
const getWidthHeight = (fontSize?: keyof typeof defaultTheme.font.size) => {
  // デフォルトのサイズをsとする
  if (!fontSize || fontSize === 's') {
    return (16 / 14) * 100;
  }
  if (fontSize === 'xs') {
    return (16 / 12) * 100;
  }
  return 100;
};

const StyledTextarea = styled.textarea((props: TextareaProps) =>
  mq({
    resize: 'none',
    width: `${getWidthHeight(props.fontSize)}%`,
    height: `${getWidthHeight(props.fontSize)}%`,
    color: props.disabled ? defaultTheme.text.gray : '',
    fontSize: getFontSize(props.fontSize),
    transform: `scale(${getTransformScale(props.fontSize)})`,
    transformOrigin: 'left top',
  }),
);

const StyledDiv = styled.div(
  (props: {
    height?: CSSObject['weight'];
    width?: CSSObject['height'];
    hasError?: boolean;
  }) =>
    mq({
      height: props.height ? props.height : '100%',
      width: props.width ? props.width : '100%',
      border: `1px solid ${
        props.hasError
          ? defaultTheme.border.color.error
          : defaultTheme.border.color.mediumLightGray
      }`,
      padding: defaultTheme.spacing.l,
      backgroundColor: props.hasError && defaultTheme.background.error,
    }),
);

const Textarea = forwardRef<any, TextareaProps>((props, ref) => {
  return (
    <StyledDiv
      height={props.height}
      width={props.width}
      hasError={props.hasError}
    >
      <StyledTextarea {...props} ref={ref} />
    </StyledDiv>
  );
});

export default Textarea;
